export default "__VITE_ASSET__DFRHbV42__"